// extracted by mini-css-extract-plugin
module.exports = {"addGiftByURL":"styles_addGiftByURL__1TbQB","text":"styles_text__1A1Ft","input_group":"styles_input_group__1hPvP","form_control":"styles_form_control__2dvB5"};